import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import Loader from "@componentsShared/Loader/Loader";
import { If } from "@componentsShared/Conditional/If";
import { Icon } from "@syarahtech/ui";
import useBoolean from "@hooks/useBoolean";
import { api__generateVirtualIBAN } from "@/apis/checkout/remainingPayments";
import { trackEvents } from "@/common/events/events";
import { copyTextToClipboard } from "@/utils/common";
import { CDN_LINK } from "@globalConfig";
var VirtualIbanSection = function VirtualIbanSection(_ref) {
  var isFinance = _ref.isFinance,
    order = _ref.order,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(null),
    virtualIbanData = _useState[0],
    setVirtualIbanData = _useState[1];
  var _useState2 = useState(""),
    copySuccessText = _useState2[0],
    setCopySuccessText = _useState2[1];
  var _useState3 = useState(null),
    isCopySuccess = _useState3[0],
    setIsCopySuccess = _useState3[1];
  var virtualIbanLoading = useBoolean();
  var isOpen = activeTab === "virtualIban";
  var handleVirtualIbanCopy = function handleVirtualIbanCopy(fieldType, value) {
    if (!window.isSecureContext) return;
    copyTextToClipboard(value);
    var successMessage = tShort("copy_msg", {
      ns: "web_common"
    });
    setIsCopySuccess("virtualIban_".concat(fieldType));
    setCopySuccessText(successMessage);
    setTimeout(function () {
      setIsCopySuccess(null);
      setCopySuccessText("");
    }, 2000);
  };
  var handleGenerateVirtualIban = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var orderId, orderType, data, _orderId, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            virtualIbanLoading.setTrue();
            orderId = isFinance ? order === null || order === void 0 ? void 0 : order.order_id : order === null || order === void 0 ? void 0 : order.id;
            orderType = isFinance ? "finance" : "cash";
            _context.n = 1;
            return api__generateVirtualIBAN({
              order_type: orderType,
              order_id: String(orderId)
            });
          case 1:
            data = _context.v;
            if (data) {
              setVirtualIbanData(data);
              trackEvents("generate_virtual_bank_clicked", {
                order_id: String(orderId),
                status: "success",
                virtual_iban: data.virtual_iban || "",
                virtual_account_number: data.account_number || ""
              });
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            _orderId = isFinance ? order === null || order === void 0 ? void 0 : order.order_id : order === null || order === void 0 ? void 0 : order.id;
            trackEvents("generate_virtual_bank_clicked", {
              order_id: String(_orderId),
              status: "failure",
              virtual_iban: "",
              virtual_account_number: ""
            });
          case 3:
            _context.p = 3;
            virtualIbanLoading.setFalse();
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function handleGenerateVirtualIban() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("li", {
    className: ["flex flex-wrap justify-between items-center px-2 py-3 border border-gray-gainsboro rounded-lg relative mb-3 border-solid", isOpen ? "border-[#0D0DB5]" : ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between cursor-pointer flex-[100%]",
    onClick: function onClick() {
      return setActiveTab(isOpen ? -1 : "virtualIban");
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex justify-start text-black text-lg font-bold ms-1"
  }, tShort("pre-checkout/bank_transfer")), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D] text-xs leading-4 mr-auto ms-1 flex items-center"
  }, tShort("pre-checkout/all_banks_available")), /*#__PURE__*/React.createElement("img", {
    className: "transition-transform duration-300 ".concat(isOpen ? "rotate-180" : ""),
    src: CDN_LINK + "/assets/images/remaining-arrow.svg",
    alt: ""
  }))), /*#__PURE__*/React.createElement(If, {
    condition: isOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(If, {
    condition: !virtualIbanData
  }, /*#__PURE__*/React.createElement("button", {
    className: "relative bg-[#0D0DB5] border-none text-white font-bold w-full h-10 rounded block mx-auto mt-6 mb-1 cursor-pointer disabled:opacity-50",
    onClick: handleGenerateVirtualIban,
    disabled: virtualIbanLoading.value
  }, tShort("pre-checkout/view_accountInfo"), /*#__PURE__*/React.createElement(If, {
    condition: virtualIbanLoading.value
  }, /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: "absolute top-0 left-0 w-full m-0 bg-transparent backdrop-blur-sm z-[9] [&>span]:w-5 [&>span]:h-5 [&>span]:border-2 [&>span::after]:w-5 [&>span::after]:h-5 [&>span::after]:border-2"
  })))), /*#__PURE__*/React.createElement(If, {
    condition: !!virtualIbanData
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] text-sm font-semibold leading-6"
  }, tShort("remaining/beneficiary_name", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-4"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-sm leading-4 text-black"
  }, tShort("remaining/company_name", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
    onClick: function onClick() {
      return handleVirtualIbanCopy("beneficiary", tShort("remaining/company_name", {
        ns: "web_tracking"
      }));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--content-copy-outline-rounded",
    className: "bg-[#154f9c]",
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] text-sm font-semibold leading-6"
  }, tShort("remaining/account_number", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-4"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-sm leading-6 text-black"
  }, (virtualIbanData === null || virtualIbanData === void 0 ? void 0 : virtualIbanData.account_number) || ""), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
    onClick: function onClick() {
      return handleVirtualIbanCopy("account_number", (virtualIbanData === null || virtualIbanData === void 0 ? void 0 : virtualIbanData.account_number) || "");
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--content-copy-outline-rounded",
    className: "bg-[#154f9c]",
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] text-sm font-semibold leading-6"
  }, "IBAN"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-4"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-sm leading-6 text-black"
  }, (virtualIbanData === null || virtualIbanData === void 0 ? void 0 : virtualIbanData.virtual_iban) || ""), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
    onClick: function onClick() {
      return handleVirtualIbanCopy("iban", (virtualIbanData === null || virtualIbanData === void 0 ? void 0 : virtualIbanData.virtual_iban) || "");
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--content-copy-outline-rounded",
    className: "bg-[#154f9c]",
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement("span", {
    className: "text-[#6c7a8d] text-sm font-semibold leading-6"
  }, tShort("pre-checkout/bank_account")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-4"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-sm leading-4 text-black"
  }, tShort("remaining/rajhi_bank", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-transparent border-none text-[#0D0DB5] text-xs font-semibold leading-4 underline p-0",
    onClick: function onClick() {
      return handleVirtualIbanCopy("bank_name", tShort("remaining/rajhi_bank", {
        ns: "web_tracking"
      }));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--content-copy-outline-rounded",
    className: "bg-[#154f9c]",
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement("section", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--info-outline",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6c7a8d] text-[12px] mx-0 px-1"
  }, tShort("pre-checkout/bank_note"))))), /*#__PURE__*/React.createElement(If, {
    condition: isCopySuccess === null || isCopySuccess === void 0 ? void 0 : isCopySuccess.startsWith("virtualIban_")
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 top-0 w-full h-full flex justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mt-[91px] min-w-[172px] w-fit h-min min-h-8 flex justify-center items-center bg-[rgba(108,122,141,0.75)] rounded-2xl text-white text-xs leading-8 px-3"
  }, copySuccessText))))));
};
export default VirtualIbanSection;